import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

/**
 * Re-usable Data Models
 * @warning WE HAVE DUPLICATION!
 * VERY LIKELY OUTDATED / SHOULD BE CONSOLIDATED WITH `provider.models.identity.ts`
 * @deprecated See `provider.models.identity.ts` for the latest version.
 */
export const ProviderIdentitySchema = z.object({
  id: z.string().uuid().openapi({ example: '123e4567-e89b-12d3-a456-426614174000' }),
  name: z.string().nullable().openapi({ example: 'John Doe' }),
  username: z.string().openapi({ example: 'johndoe' }).nullable(),
  email: z.string().nullable().openapi({ example: 'john@doe.com' }),
  avatar_url: z.string().nullable().openapi({ example: 'https://example.com/avatar.png' }),
  verified: z.boolean().openapi({ example: true, description: 'Whether the identity is verified' }),
  connection_id: z
    .string()
    .uuid()
    .nullable()
    .openapi({ example: '123e4567-e89b-12d3-a456-426614174000' }),
});

/**
 * @warning WE HAVE DUPLICATION!
 * VERY LIKELY OUTDATED / SHOULD BE CONSOLIDATED WITH `provider.models.identity.ts`
 * @deprecated See `provider.models.identity.ts` for the latest version.
 */
export const CreateIdentitySchema = z.object({
  /**
   * An universal identifier of this user (usually URL to "user's profile page'")
   * @example https://github.com/t1mmen
   * */
  uri: z
    .string()
    .openapi({ description: 'URI to user profile', example: 'https://github.com/t1mmen' }),
  /**
   * External username
   * @example t1mmen
   */
  external_username: z
    .string()
    .optional()
    .openapi({ description: 'External username', example: 't1mmen' }),
  /**
   * External Email address
   * @example timm@stokke.me
   */
  external_email: z
    .string()
    .email()
    .optional()
    .openapi({ description: 'External email address', example: 'timm@stokke.me' }),
  /**
   * Users full name on the external service
   * @example Timm Stokke
   */
  external_name: z
    .string()
    .optional()
    .openapi({ description: 'External name', example: 'Timm Stokke' }),
  /**
   * External user id (as string)
   * @example '123456'
   */
  external_user_id: z
    .string()
    .optional()
    .openapi({ description: 'External user ID', example: '123456' }),
  /**
   * External timezone
   * @example 'Europe/Oslo'
   */
  external_timezone: z
    .string()
    .optional()
    .optional()
    .openapi({ description: 'External timezone', example: 'Europe/Oslo' }),
  /**
   * External avatar URL, if available
   * @example https://avatars.githubusercontent.com/u/123456?v=4
   */
  avatar_url: z.string().url().optional().openapi({
    description: 'External avatar URL',
    example: 'https://avatars.githubusercontent.com/u/123456?v=4',
  }),
  /**
   * Is this identity verified? E.g, is the email address truely owned by them?
   */
  verified: z
    .boolean()
    .optional()
    .openapi({ description: 'Is this identity verified?', example: true }),
});
